import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import timeZones from 'store/app/entities/config/timeZones/action';
import authEmployee from 'store/selectors/authEmployee';

const mapStateToProps = state => ({
  timeZones: state.config.timeZones,
  settings: authEmployee(state)?.settings,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    config: {
      timeZones: bindActionCreators(timeZones, dispatch),
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
